import type { Locale } from "@porsche-customer/slfinrtl-context-types"
import type { ApiRoute, NoBody } from "../../api"
import type { DocumentResponse } from "../../common"

export interface GenerateExposePathParams {
	inventoryId: string
	languageTag: Locale
}
export interface GenerateExposeQuery {
	withFsOffer: "true" | "false"
}
export const generateExposeRoute: ApiRoute<GenerateExposePathParams, GenerateExposeQuery, NoBody, DocumentResponse> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/expose/${params.languageTag}`,
	method: "get",
	path: "/vehicles/:inventoryId/expose/:languageTag",
}
